import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { FiHome, FiUser, FiChevronRight } from 'react-icons/fi';
import { Layout } from '../components/Layout';

export function SetupSecretary() {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    fullName: '',
    secretaryName: '',
    companyName: '',
    secretaryTone: '',
    companyDescription: '',
    secretaryIntroduction: '',
    userRole: '',
    secretaryResponsibility: '',
    userGoal: '',
    phoneNumber: '',
  });
  
  // Radio options
  const [computerSkill, setComputerSkill] = useState('');
  const [secretaryGrant, setSecretaryGrant] = useState('');
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", { ...formData, computerSkill, secretaryGrant });
    // Here you would save the data to your backend
    
    // Navigate back to the onboard page with state
    navigate('/onboard', { state: { completedStep: 1 }});
  };
  
  return (
    <div className="flex-1 overflow-auto">
      <div className="max-w-5xl mx-auto px-6 py-6">
        {/* Header with navigation steps */}
        <div className="mb-8">
          <div className="flex justify-between items-center mb-3">
            <h1 className="text-2xl font-semibold">Welcome to Secrely</h1>
            <Button size="sm" variant="outline" onClick={() => navigate('/')} className="flex items-center gap-2">
              <FiHome size={14} />
              Return to App
            </Button>
          </div>
          
          {/* Steps navigation */}
          <div className="flex justify-between items-center mb-10">
            <div className="flex flex-col items-center flex-1">
              <div className="w-8 h-8 rounded-full bg-blue-500 text-white flex items-center justify-center text-sm mb-2">1</div>
              <span className="text-sm font-medium">Set up</span>
            </div>
            <div className="h-0.5 flex-1 bg-gray-200">
              <div className="h-full bg-blue-500" style={{ width: '0%' }}></div>
            </div>
            <div className="flex flex-col items-center flex-1">
              <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-500 flex items-center justify-center text-sm mb-2">2</div>
              <span className="text-sm text-gray-500">Schedule</span>
            </div>
            <div className="h-0.5 flex-1 bg-gray-200">
              <div className="h-full bg-blue-500" style={{ width: '0%' }}></div>
            </div>
            <div className="flex flex-col items-center flex-1">
              <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-500 flex items-center justify-center text-sm mb-2">3</div>
              <span className="text-sm text-gray-500">Import</span>
            </div>
            <div className="h-0.5 flex-1 bg-gray-200">
              <div className="h-full bg-blue-500" style={{ width: '0%' }}></div>
            </div>
            <div className="flex flex-col items-center flex-1">
              <div className="w-8 h-8 rounded-full bg-gray-200 text-gray-500 flex items-center justify-center text-sm mb-2">4</div>
              <span className="text-sm text-gray-500">Integrate</span>
            </div>
          </div>
          
          {/* Form title */}
          <div className="mb-8">
            <h2 className="text-xl font-semibold">Set up your secretary</h2>
            <p className="text-sm text-gray-500 mt-1">Tell us a bit about yourself and preference</p>
          </div>
          
          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-8">
            {/* Two column layout for form fields */}
            <div className="grid grid-cols-2 gap-6">
              {/* Left column */}
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Full name
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                      <FiUser size={16} />
                    </span>
                    <Input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      placeholder="Enter your full name"
                      className="pl-10"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Company Name
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                      <FiUser size={16} />
                    </span>
                    <Input
                      type="text"
                      name="companyName"
                      value={formData.companyName}
                      onChange={handleInputChange}
                      placeholder="Enter your job title"
                      className="pl-10"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Company Description
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                      <FiUser size={16} />
                    </span>
                    <Input
                      type="text"
                      name="companyDescription"
                      value={formData.companyDescription}
                      onChange={handleInputChange}
                      placeholder="Enter your job title"
                      className="pl-10"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Role
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                      <FiUser size={16} />
                    </span>
                    <Input
                      type="text"
                      name="userRole"
                      value={formData.userRole}
                      onChange={handleInputChange}
                      placeholder="Enter your job title"
                      className="pl-10"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Goal
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                      <FiUser size={16} />
                    </span>
                    <Input
                      type="text"
                      name="userGoal"
                      value={formData.userGoal}
                      onChange={handleInputChange}
                      placeholder="Enter your job title"
                      className="pl-10"
                    />
                  </div>
                </div>
              </div>
              
              {/* Right column */}
              <div className="space-y-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Secretary name
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                      <FiUser size={16} />
                    </span>
                    <Input
                      type="text"
                      name="secretaryName"
                      value={formData.secretaryName}
                      onChange={handleInputChange}
                      placeholder="Enter your full name"
                      className="pl-10"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Secretary tone/style
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                      <FiUser size={16} />
                    </span>
                    <Input
                      type="text"
                      name="secretaryTone"
                      value={formData.secretaryTone}
                      onChange={handleInputChange}
                      placeholder="Enter your full name"
                      className="pl-10"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Secretary Introduction/Description
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                      <FiUser size={16} />
                    </span>
                    <Input
                      type="text"
                      name="secretaryIntroduction"
                      value={formData.secretaryIntroduction}
                      onChange={handleInputChange}
                      placeholder="Enter your job title"
                      className="pl-10"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Secretary Responsibility
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                      <FiUser size={16} />
                    </span>
                    <Input
                      type="text"
                      name="secretaryResponsibility"
                      value={formData.secretaryResponsibility}
                      onChange={handleInputChange}
                      placeholder="Enter your job title"
                      className="pl-10"
                    />
                  </div>
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Your Phone Number
                  </label>
                  <div className="relative">
                    <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">
                      <FiUser size={16} />
                    </span>
                    <Input
                      type="tel"
                      name="phoneNumber"
                      value={formData.phoneNumber}
                      onChange={handleInputChange}
                      placeholder="Enter your job title"
                      className="pl-10"
                    />
                  </div>
                </div>
              </div>
            </div>
            
            {/* Computer skill selection */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">
                Your Computer Skill
              </label>
              <div className="grid grid-cols-2 gap-4">
                <div 
                  className={`border rounded-md p-4 cursor-pointer flex items-start ${computerSkill === 'advanced' ? 'border-blue-500 bg-blue-50' : 'hover:bg-gray-50'}`}
                  onClick={() => setComputerSkill('advanced')}
                >
                  <div className="flex items-center h-5 mt-0.5">
                    <input
                      type="radio"
                      name="computerSkill"
                      checked={computerSkill === 'advanced'}
                      onChange={() => setComputerSkill('advanced')}
                      className="h-4 w-4 text-blue-600 border-gray-300"
                    />
                  </div>
                  <div className="ml-3">
                    <label className="font-medium text-gray-800 block mb-1">Advanced</label>
                    <p className="text-gray-500 text-sm">Experience with multiple softwares</p>
                  </div>
                </div>
                
                <div 
                  className={`border rounded-md p-4 cursor-pointer flex items-start ${computerSkill === 'intermediate' ? 'border-blue-500 bg-blue-50' : 'hover:bg-gray-50'}`}
                  onClick={() => setComputerSkill('intermediate')}
                >
                  <div className="flex items-center h-5 mt-0.5">
                    <input
                      type="radio"
                      name="computerSkill"
                      checked={computerSkill === 'intermediate'}
                      onChange={() => setComputerSkill('intermediate')}
                      className="h-4 w-4 text-blue-600 border-gray-300"
                    />
                  </div>
                  <div className="ml-3">
                    <label className="font-medium text-gray-800 block mb-1">Intermediate</label>
                    <p className="text-gray-500 text-sm">Basic office knowledge</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Secretary grant section */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-3">
                Grant your secretary
              </label>
              <div className="grid grid-cols-2 gap-4">
                <div 
                  className={`border rounded-md p-4 cursor-pointer flex items-start ${secretaryGrant === 'authorization' ? 'border-blue-500 bg-blue-50' : 'hover:bg-gray-50'}`}
                  onClick={() => setSecretaryGrant('authorization')}
                >
                  <div className="flex items-center h-5 mt-0.5">
                    <input
                      type="radio"
                      name="secretaryGrant"
                      checked={secretaryGrant === 'authorization'}
                      onChange={() => setSecretaryGrant('authorization')}
                      className="h-4 w-4 text-blue-600 border-gray-300"
                    />
                  </div>
                  <div className="ml-3">
                    <label className="font-medium text-gray-800 block mb-1">Authorization</label>
                    <p className="text-gray-500 text-sm">Call your contacts via your number</p>
                  </div>
                </div>
                
                <div 
                  className={`border rounded-md p-4 cursor-pointer flex items-start ${secretaryGrant === 'right' ? 'border-blue-500 bg-blue-50' : 'hover:bg-gray-50'}`}
                  onClick={() => setSecretaryGrant('right')}
                >
                  <div className="flex items-center h-5 mt-0.5">
                    <input
                      type="radio"
                      name="secretaryGrant"
                      checked={secretaryGrant === 'right'}
                      onChange={() => setSecretaryGrant('right')}
                      className="h-4 w-4 text-blue-600 border-gray-300"
                    />
                  </div>
                  <div className="ml-3">
                    <label className="font-medium text-gray-800 block mb-1">Right</label>
                    <p className="text-gray-500 text-sm">Communicate with you constantly via your cell</p>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Submit button */}
            <div className="flex justify-end">
              <Button type="submit" className="px-6">
                Continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Wrapped component with layout
export function SetupSecretaryPage() {
  return (
    <Layout>
      <SetupSecretary />
    </Layout>
  );
} 